import React from 'react';
import './Square.css';
import classNames from 'classnames';
import { getImgSrc } from '../../helpers/getImageSrc';

const Square = ({ value, onClick, turn, winner, playerName, playerImg, isPlayable, isStealable, isReinforceable, isLocked, isShielded, stealFlash, claims, isChosen }) => {
    // isPlayable es opcional: si no viene definido (Online, etc.), se mantiene el comportamiento
    // de siempre (solo casillas vacías). En Modo Robo, isPlayable es true para CUALQUIER casilla
    // ocupada (el click siempre llega a la página, que decide qué feedback dar).
    const handleClick = () => {
        const clickable = typeof isPlayable === 'boolean' ? isPlayable : value === '';
        if (turn !== null && clickable) {
            onClick();
        }
    };

    const squareClass = classNames({
        square: true,
        'square--X': value === 'X',
        'square--O': value === 'O',
        'square--winner': winner,
        'square--stealable': isStealable === true,
        'square--reinforceable': isReinforceable === true,
        'square--locked': isLocked === true,
        'square--shielded': isShielded === true,
        'square--steal-flash': stealFlash === true,
        'square--chosen': isChosen === true,
    });

    return (
        <div className={squareClass} onClick={handleClick}>
            {isLocked && (
                <span className="sq-locked-badge" title={isShielded ? 'Casilla blindada para siempre' : 'Tope de jugadas alcanzado'}>
                    {isShielded ? '🛡️' : '🔒'}
                </span>
            )}
            {value !== '' && claims > 1 && (
                <span className="sq-claims-badge" title={`Jugada ${claims} vez(es) en esta casilla`}>x{claims}</span>
            )}
            {value !== '' && (
                playerImg ? (
                    <>
                        <div className={`sq-photo-wrap${playerImg && playerImg.includes('transfermarkt') ? ' sq-photo-wrap--tm' : ''}`}>
                            <img
                                src={getImgSrc(playerImg)}
                                alt={playerName || ''}
                                className={`sq-photo${playerImg && playerImg.includes('transfermarkt') ? ' sq-photo--tm' : ''}`}
                            />
                        </div>
                        {playerName && <span className="sq-name">{playerName}</span>}
                    </>
                ) : playerName ? (
                    <span className="sq-name sq-name--only">{playerName}</span>
                ) : null
            )}
        </div>
    );
};

export default Square;
